import * as Utils from 'app/blocks/common/utils';
import routes from 'app/pages/routes.json';
import { navigate, reload } from 'app/route/history';

export default {
    getURL(pageName: string, props?: Record<string, any>): string {
        return Utils.template(routes[pageName], { props });
    },
    home(replace: boolean = false) {
        navigate('', { replace });
    },
    navigate(pageName: string, props?: Record<string, any>) {
        navigate(this.getURL(pageName, props));
    },
    navigateToDashboard() {
        setTimeout(() => navigate(routes.dashboard));
    },
    navigateToUrl(url: string, params?: { replace: boolean }, paramsForNextRoute?: Record<string, any>) {
        setTimeout(() => navigate(url, params, paramsForNextRoute));
    },
    reload() {
        reload();
    },
    toArticlePage(articleId: string) {
        navigate(`/index.html/article/${articleId}`);
    },
    toLogin({ email = '', replace = false } = {}) {
        return navigate(`/index.html/login${email ? `?email=${email}` : ''}`, { replace });
    },
};
